import HomeSlider from "./home-slider"

export default HomeSlider
